"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceLabel = exports.ReferenceLabelValidationError = void 0;
const typegate_1 = require("typegate");
class ReferenceLabelValidationError extends Error {
    // @ts-expect-error
    tag;
}
exports.ReferenceLabelValidationError = ReferenceLabelValidationError;
class ReferenceLabel {
    // The private readonly tag prevents callers for using the 'as' keyword to cast unvalidated ReferenceLabel value.
    // Removing this property would be less safe.
    // @ts-ignore
    tag;
    _value;
    constructor(validatedReferenceLabel) {
        this.tag = 'ReferenceLabel';
        this._value = validatedReferenceLabel;
    }
    get value() {
        return this._value;
    }
    static create(referenceLabel) {
        if (!this.isValidPrefix(referenceLabel)) {
            const msg = `The reference label '${referenceLabel}' is invalid. Reference labels must begin with a letter.`;
            return (0, typegate_1.failure)(new ReferenceLabelValidationError(msg));
        }
        if (!this.isValidCharacters(referenceLabel)) {
            const msg = `The reference label '${referenceLabel}' is invalid. Reference labels must contain only letters, numbers and underscore.`;
            return (0, typegate_1.failure)(new ReferenceLabelValidationError(msg));
        }
        return (0, typegate_1.success)(new ReferenceLabel(referenceLabel));
    }
    static isValidCharacters(referenceLabel) {
        const numbersLettersAndUnderscores = /^[a-zA-Z0-9_]+$/;
        return numbersLettersAndUnderscores.test(referenceLabel);
    }
    static isValidPrefix(referenceLabel) {
        const startsWithLetter = /^[a-zA-Z].*/;
        return startsWithLetter.test(referenceLabel);
    }
}
exports.ReferenceLabel = ReferenceLabel;
